function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
const trapFocusHandlers = {};
function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];
  removeTrapFocus();
  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;
    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };
  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };
  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }
    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };
  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  elementToFocus.focus();
}
function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document
    .querySelectorAll("product-model")
    .forEach((model) => model.modelViewerUI?.pause());
}
function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);
  if (elementToFocus) elementToFocus.focus();
}
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define("quantity-input", QuantityInput);
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};
function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}
/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}
Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};
Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};
Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};
Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};
  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);
  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};
Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );
  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );
  this.initCountry();
  this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },
  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },
  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);
    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }
      this.provinceContainer.style.display = "";
    }
  },
  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },
  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.header = document.getElementById("shopify-section-global--header");
    this.headerBounds = {};
    this.currentScrollTop = 0;
    this.onScrollHandler = this.onScroll.bind(this);
    window.addEventListener("scroll", this.onScrollHandler, false);
    this.createObserver();
  }
  disconnectedCallback() {
    window.removeEventListener("scroll", this.onScrollHandler);
  }
  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.header);
  }
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > this.currentScrollTop && scrollTop) {
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop) {
      requestAnimationFrame(this.reveal.bind(this));
    } else if (scrollTop <= this.headerBounds.top) {
      requestAnimationFrame(this.reset.bind(this));
    }
    this.currentScrollTop = scrollTop;
  }
  hide() {
    this.header.classList.add("global--header--sticky");
  }
  reveal() {
    this.header.classList.add("global--header--sticky");
  }
  reset() {
    this.header.classList.remove("global--header--sticky");
  }
}
customElements.define("sticky-header", StickyHeader);
class MobileMenu extends HTMLElement {
  constructor() {
    super();
    this.opener = this.querySelector("[data-mobile-menu-trigger]");
    this.icon = this.querySelector(".global--header--mobile-menu__icon");
    this.nav = this.querySelector(".global--header--mobile-menu__content");
    this.closer = this.querySelector("[data-mobile-menu-closer]");
    this.megaTriggers = this.querySelectorAll("[data-mobile-mega-trigger]");
    this.megaBack = this.querySelector('[data-mobile-mega-back]');
    this.bindEvents();
  }
  bindEvents() {
    this.opener.addEventListener("click", this.toggleMenu.bind(this));
    this.closer.addEventListener("click", this.toggleMenu.bind(this));
    this.megaBack.addEventListener("click", this.closeMega.bind(this));
    let _this = this;
    document.querySelector('body').addEventListener("click", function(e) {
      if (e.target == document.querySelector('body') && e.target.classList.contains('lock-scroll')) {
        _this.toggleMenu();
      }
    });
    this.megaTriggers.forEach(function (megaTrigger) {
      megaTrigger.addEventListener("click", _this.openMega.bind(megaTrigger));
    });
  }
  openMega(e) {
    let megaTrigger = e.target.closest('.mobile-shop__block');
    let title = megaTrigger.dataset.megaTitle;
    document.querySelector(`.mega-menu[data-mega-title="${title}"]`).classList.add('mega-menu--active');
    document.querySelector('.global--header--mobile-menu__back').classList.add('global--header--mobile-menu__back--active');
  }
  closeMega() {
    this.querySelector(`.mega-menu--active`).classList.remove('mega-menu--active');
    document.querySelector('.global--header--mobile-menu__back').classList.remove('global--header--mobile-menu__back--active');
  }
  toggleMenu() {
    if (
      this.opener.classList.contains(
        "global--header--mobile-menu__wrapper--active"
      )
    ) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }
  openMenu() {
    this.nav.classList.add("global--header--mobile-menu__content--active");
    this.icon.classList.add("global--header--mobile-menu__icon--active");
    this.opener.classList.add("global--header--mobile-menu__wrapper--active");
    document.querySelector('body').classList.add('lock-scroll');
  }
  closeMenu() {
    this.nav.classList.remove("global--header--mobile-menu__content--active");
    this.icon.classList.remove("global--header--mobile-menu__icon--active");
    this.opener.classList.remove(
      "global--header--mobile-menu__wrapper--active"
    );
    document.querySelector('body').classList.remove('lock-scroll');
  }
}
customElements.define("mobile-menu", MobileMenu);
class MegaMenu extends HTMLElement {
  constructor() {
    super();
    this.hover = false;
    this.opener = this.parentElement.querySelector("[data-mega-menu-trigger]");
    this.content = this.querySelector(".global--header--mega-menu__content");
    this.bindEvents();
  }
  bindEvents() {
    this.opener.addEventListener("mouseenter", this.openMenu.bind(this));
    this.opener.addEventListener("mouseleave", this.closeMenu.bind(this));
    this.content.addEventListener("mouseenter", this.openMenu.bind(this));
    this.content.addEventListener("mouseleave", this.closeMenu.bind(this));
  }
  toggleMenu() {
    if (
      this.opener.classList.contains(
        "global--header--mega-menu__wrapper--active"
      )
    ) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }
  openMenu() {
    this.content.classList.add("global--header--mega-menu__content--active");
    this.opener.classList.add("global--header--primary-menu__item--active");
    document
      .querySelector(".global--header")
      .classList.add("global--header--sticky");
    document.querySelector('body').classList.add('body--overlay');
  }
  closeMenu() {
    this.content.classList.remove("global--header--mega-menu__content--active");
    this.opener.classList.remove("global--header--primary-menu__item--active");
    document
      .querySelector(".global--header")
      .classList.remove("global--header--sticky");
    document.querySelector('body').classList.remove('body--overlay');
  }
}
customElements.define("mega-menu", MegaMenu);
class FooterMobileMenu extends HTMLElement {
  constructor() {
    super();
    this.footerAccordions = document.querySelectorAll(
      ".component--footer--mobile-menu__item"
    );
    this.footerAccordionButtons = document.querySelectorAll(
      ".component--footer--mobile-menu__titles"
    );
    this.bindEvents();
  }
  bindEvents() {
    this.footerAccordionButtons.forEach((accordion) =>
      accordion.addEventListener("click", this.toggleFooterAccordion.bind(this))
    );
  }
  toggleFooterAccordion(event) {
    const element = event.currentTarget;
    for (let i = 0; i < this.footerAccordions.length; i++) {
      if (element == this.footerAccordionButtons[i]) {
        this.footerAccordions[i].classList.toggle(
          "component--footer--mobile-menu__item--active"
        );
      } else {
        this.footerAccordions[i].classList.remove(
          "component--footer--mobile-menu__item--active"
        );
      }
    }
  }
}
customElements.define("footer-mobile-menu", FooterMobileMenu);
class FooterNewsletter extends HTMLElement {
  constructor() {
    super();
    this.defaults = {
      newsletter: ".component--footer--newsletter__form",
      newsletterInput: ".component--footer--newsletter__input",
      newsletterInputField: ".component--footer--newsletter__field",
      newsletterMessages: ".component--footer--newsletter__messages",
      successMessage: ".component--footer--newsletter__success-message",
      errorMessage: ".component--footer--newsletter__error-message",
    };
    this.newsletter = document.querySelector(this.defaults.newsletter);
    this.newsletterInput = document.querySelector(
      this.defaults.newsletterInput
    );
    this.newsletterInputField = document.querySelector(
      this.defaults.newsletterInputField
    );
    this.newsletterMessages = document.querySelector(
      this.defaults.newsletterMessages
    );
    this.newsletterSuccessMessage = document.querySelector(
      this.defaults.successMessage
    );
    this.newsletterErrorMessage = document.querySelector(
      this.defaults.errorMessage
    );
    this.bindEvents();
  }
  bindEvents() {
    this.newsletter.addEventListener("submit", this.submitForm.bind(this));
  }
  successMessages() {
    this.newsletterSuccessMessage.style.display = "block";
    this.newsletterErrorMessage.style.display = "none";
    this.newsletterInputField.style.display = "none";
    setTimeout(() => {
      this.resetForm();
    }, 5000);
  }
  errorMessages(ele, error) {
    const html = `<svg width="12" height="12" viewBox="0 0 12 12" fill="#e2665c" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 0C2.6934 0 0 2.6934 0 6C0 9.3066 2.6934 12 6 12C9.3066 12 12 9.3066 12 6C12 2.6934 9.3066 0 6 0ZM6 1.2C8.65807 1.2 10.8 3.34193 10.8 6C10.8 8.65807 8.65807 10.8 6 10.8C3.34193 10.8 1.2 8.65807 1.2 6C1.2 3.34193 3.34193 1.2 6 1.2ZM5.4 3V4.2H6.6V3H5.4ZM5.4 5.4V9H6.6V5.4H5.4Z" />
            </svg><span>${error}</span>`;
    ele.innerHTML = html;
    ele.style.display = "block";
    this.newsletterInput.style.border = "2px solid #e2665c";
  }
  resetForm() {
    this.newsletterSuccessMessage.style.display = "none";
    this.newsletterErrorMessage.style.display = "none";
    this.newsletterErrorMessage.innerHTML = "";
    this.newsletterInputField.style.display = "flex";
    this.newsletterInput.value = "";
  }
  validateEmail(email) {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
  subscribe(id, email) {
    const data = {
      g: id,
      email: email,
      $source: "Website Footer",
    };
    const urlData = new URLSearchParams(data);
    const url = "https://manage.kmail-lists.com/ajax/subscriptions/subscribe";
    fetch(url, {
      method: "POST",
      async: true,
      crossDomain: true,
      body: urlData,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Cache-Control": "no-cache",
      },
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.success) {
          if (res.data.is_subscribed) {
            this.errorMessages(
              this.newsletterErrorMessage,
              "This email address has already subscribed."
            );
          } else {
            this.successMessages();
          }
        } else {
          this.errorMessages(
            this.newsletterErrorMessage,
            "Invalid Email Address."
          );
        }
      })
      .catch((err) => {
        this.errorMessages(
          this.newsletterErrorMessage,
          "Something went wrong!"
        );
      });
  }
  formToJSON(elements) {
    return [].reduce.call(
      elements,
      function (data, element) {
        data[element.name] = element.value;
        return data;
      },
      {}
    );
  }
  // Get Shopify Friendly URL String
  getUrlString(data) {
    var urlParameters = Object.entries(data)
      .map(function (e) {
        return e.join("=");
      })
      .join("&");
    return urlParameters;
  }
  shopifyForm() {
    var action = this.newsletter.getAttribute("action");
    const inputs = this.newsletter.querySelectorAll("[name]");
    fetch(action, {
      method: "POST",
      body: this.getUrlString(this.formToJSON(inputs)),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        Accept: "text/html, */*; q=0.01",
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then((response) => {
        console.log(response);
        console.log(response.status);
        if (response.status == 200) {
          this.successMessages();
        } else {
          this.errorMessages(
            this.newsletterErrorMessage,
            "Invalid Email Address."
          );
        }
      })
      .catch((err) => {
        console.error(err);
        this.errorMessages(
          this.newsletterErrorMessage,
          "Something went wrong!"
        );
      });
  }
  submitForm(e) {
    e.preventDefault();
    //const email = this.newsletter.elements["contact[email]"].value;
    const email = this.newsletter.elements["email"].value;
    const listId = this.newsletter.elements["g"].value;
    if (email !== "") {
      if (this.validateEmail(email)) {
        //this.shopifyForm();
        this.subscribe(listId, email);
      } else {
        this.errorMessages(
          this.newsletterErrorMessage,
          "Invalid Email Address."
        );
      }
    } else {
      this.errorMessages(
        this.newsletterErrorMessage,
        "Email Address Required."
      );
    }
    return false;
  }
}
customElements.define("footer-newsletter", FooterNewsletter);
// class ContactForm extends HTMLElement {
//   constructor() {
//     super();
//     this.defaults = {
//       form: ".global--contact-form__forms",
//       newsletterInput: ".global--contact-form__inputs",
//       newsletterInputField: ".global--contact-form__fields",
//       newsletterMessages: ".global--contact-form__messagess",
//       successMessage: ".global--contact-form__success-messages",
//       errorMessage: ".global--contact-form__error-messages",
//     };
//     this.form = document.querySelector(this.defaults.form);
//     this.newsletterInput = document.querySelectorAll(
//       this.defaults.newsletterInput
//     );
//     this.newsletterInputField = document.querySelector(
//       this.defaults.newsletterInputField
//     );
//     this.newsletterMessages = document.querySelector(
//       this.defaults.newsletterMessages
//     );
//     this.newsletterSuccessMessage = document.querySelector(
//       this.defaults.successMessage
//     );
//     this.newsletterErrorMessage = document.querySelector(
//       this.defaults.errorMessage
//     );
//     this.bindEvents();
//     if (window.location.href.indexOf("#contact") != -1) {
//       this.openForm();
//     }
//   }
//   bindEvents() {
//     document.querySelectorAll('[href="#contact"]').forEach((ele) => {
//       ele.addEventListener("click", this.openForm.bind(this));
//     });
//     document.querySelectorAll("[data-contact-form-close]").forEach((ele) => {
//       ele.addEventListener("click", this.closeForm.bind(this));
//     });
//     this.form.addEventListener("submit", this.submitForm.bind(this));
//   }
//   successMessages() {
//     this.newsletterSuccessMessage.style.display = "block";
//     this.newsletterErrorMessage.style.display = "none";
//     this.form.style.display = "none";
//     setTimeout(() => {
//       this.resetForm();
//     }, 5000);
//   }
//   errorMessages(ele, error) {
//     const html = `<svg width="12" height="12" viewBox="0 0 12 12" fill="#e2665c" xmlns="http://www.w3.org/2000/svg">
//                 <path d="M6 0C2.6934 0 0 2.6934 0 6C0 9.3066 2.6934 12 6 12C9.3066 12 12 9.3066 12 6C12 2.6934 9.3066 0 6 0ZM6 1.2C8.65807 1.2 10.8 3.34193 10.8 6C10.8 8.65807 8.65807 10.8 6 10.8C3.34193 10.8 1.2 8.65807 1.2 6C1.2 3.34193 3.34193 1.2 6 1.2ZM5.4 3V4.2H6.6V3H5.4ZM5.4 5.4V9H6.6V5.4H5.4Z" />
//             </svg><span>${error}</span>`;
//     ele.innerHTML = html;
//     ele.style.display = "block";
//   }
//   resetForm() {
//     this.newsletterSuccessMessage.style.display = "none";
//     this.newsletterErrorMessage.style.display = "none";
//     this.newsletterErrorMessage.innerHTML = "";
//     this.form.style.display = "block";
//     this.newsletterInput.forEach((item) => {
//       item.value = "";
//     });
//     document.querySelector(".global--contact-form__textarea").value = "";
//   }
//   validateEmail(email) {
//     const re =
//       /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
//     return re.test(String(email).toLowerCase());
//   }
//   formToJSON(elements) {
//     return [].reduce.call(
//       elements,
//       function (data, element) {
//         data[element.name] = element.value;
//         return data;
//       },
//       {}
//     );
//   }
//   // Get Shopify Friendly URL String
//   getUrlString(data) {
//     var urlParameters = Object.entries(data)
//       .map(function (e) {
//         return e.join("=");
//       })
//       .join("&");
//     return urlParameters;
//   }
//   shopifyForm() {
//     var action = this.form.getAttribute("action");
//     const inputs = this.form.querySelectorAll("[name]");
//     fetch(action, {
//       method: "POST",
//       body: this.getUrlString(this.formToJSON(inputs)),
//       headers: {
//         "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
//         Accept: "text/html, */*; q=0.01",
//         "X-Requested-With": "XMLHttpRequest",
//       },
//     })
//       .then((response) => {
//         if (response.status == 200) {
//           this.successMessages();
//         } else {
//           this.errorMessages(
//             this.newsletterErrorMessage,
//             "Something went wrong!"
//           );
//         }
//       })
//       .catch((err) => {
//         console.error(err);
//         this.errorMessages(
//           this.newsletterErrorMessage,
//           "Something went wrong!"
//         );
//       });
//   }
//   submitForm(e) {
//     e.preventDefault();
//     const firstName = this.form.elements["contact[first_name]"].value;
//     const lastName = this.form.elements["contact[last_name]"].value;
//     const email = this.form.elements["contact[email]"].value;
//     const messge = this.form.elements["contact[body]"].value;
//     console.log("submited", email);
//     if (firstName !== "" && lastName !== "" && email !== "" && messge !== "") {
//       if (this.validateEmail(email)) {
//         this.shopifyForm();
//       } else {
//         this.errorMessages(
//           this.newsletterErrorMessage,
//           "Invalid Email Address."
//         );
//       }
//     } else {
//       this.errorMessages(
//         this.newsletterErrorMessage,
//         "Please fill out the required fields."
//       );
//     }
//     return false;
//   }
//   openForm(e) {
//     if (e) {
//       e.preventDefault();
//     }
//     console.log("open form");
//     this.openFormDrawer();
//     this.openFormOverlay();
//   }
//   openFormDrawer() {
//     document
//       .querySelector(".global--contact-form__container")
//       .classList.add("global--contact-form__container--active");
//   }
//   closeFormDrawer() {
//     document
//       .querySelector(".global--contact-form__container")
//       .classList.remove("global--contact-form__container--active");
//   }
//   closeForm() {
//     window.location.hash = "";
//     this.closeFormDrawer();
//     this.closeFormOverlay();
//     this.resetForm();
//   }
//   openFormOverlay() {
//     document.body.classList.add("is-overlay-opened");
//     document
//       .querySelector(".global--contact-form__overlay")
//       .classList.add("global--contact-form__overlay--active");
//   }
//   closeFormOverlay() {
//     document.body.classList.remove("is-overlay-opened");
//     document
//       .querySelector(".global--contact-form__overlay")
//       .classList.remove("global--contact-form__overlay--active");
//   }
// }
// customElements.define("contact-form", ContactForm);
class BlogPostNewsletter extends HTMLElement {
  constructor() {
    super();
    this.defaults = {
      newsletter: ".component--blog-post--newsletter__form",
      newsletterInput: ".component--blog-post--newsletter__input",
      newsletterInputField: ".component--blog-post--newsletter__field",
      newsletterMessages: ".component--blog-post--newsletter__messages",
      successMessage: ".component--blog-post--newsletter__success-message",
      errorMessage: ".component--blog-post--newsletter__error-message",
    };
    this.newsletter = document.querySelector(this.defaults.newsletter);
    this.newsletterInput = document.querySelector(
      this.defaults.newsletterInput
    );
    this.newsletterInputField = document.querySelector(
      this.defaults.newsletterInputField
    );
    this.newsletterMessages = document.querySelector(
      this.defaults.newsletterMessages
    );
    this.newsletterSuccessMessage = document.querySelector(
      this.defaults.successMessage
    );
    this.newsletterErrorMessage = document.querySelector(
      this.defaults.errorMessage
    );
    this.bindEvents();
  }
  bindEvents() {
    this.newsletter.addEventListener("submit", this.submitForm.bind(this));
  }
  successMessages() {
    this.newsletterSuccessMessage.style.display = "block";
    this.newsletterErrorMessage.style.display = "none";
    this.newsletterInputField.style.display = "none";
    setTimeout(() => {
      this.resetForm();
    }, 5000);
  }
  errorMessages(ele, error) {
    const html = `<svg width="12" height="12" viewBox="0 0 12 12" fill="#e2665c" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 0C2.6934 0 0 2.6934 0 6C0 9.3066 2.6934 12 6 12C9.3066 12 12 9.3066 12 6C12 2.6934 9.3066 0 6 0ZM6 1.2C8.65807 1.2 10.8 3.34193 10.8 6C10.8 8.65807 8.65807 10.8 6 10.8C3.34193 10.8 1.2 8.65807 1.2 6C1.2 3.34193 3.34193 1.2 6 1.2ZM5.4 3V4.2H6.6V3H5.4ZM5.4 5.4V9H6.6V5.4H5.4Z" />
            </svg><span>${error}</span>`;
    ele.innerHTML = html;
    ele.style.display = "block";
    this.newsletterInput.style.border = "2px solid #e2665c";
  }
  resetForm() {
    this.newsletterSuccessMessage.style.display = "none";
    this.newsletterErrorMessage.style.display = "none";
    this.newsletterErrorMessage.innerHTML = "";
    this.newsletterInputField.style.display = "block";
    this.newsletterInput.value = "";
  }
  validateEmail(email) {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
  formToJSON(elements) {
    return [].reduce.call(
      elements,
      function (data, element) {
        data[element.name] = element.value;
        return data;
      },
      {}
    );
  }
  getUrlString(data) {
    var urlParameters = Object.entries(data)
      .map(function (e) {
        return e.join("=");
      })
      .join("&");
    return urlParameters;
  }
  shopifyForm() {
    var action = this.newsletter.getAttribute("action");
    const inputs = this.newsletter.querySelectorAll("[name]");
    fetch(action, {
      method: "POST",
      body: this.getUrlString(this.formToJSON(inputs)),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        Accept: "text/html, */*; q=0.01",
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then((response) => {
        if (response.status == 200) {
          this.successMessages();
        } else {
          this.errorMessages(
            this.newsletterErrorMessage,
            "Invalid Email Address."
          );
        }
      })
      .catch((err) => {
        console.error(err);
        this.errorMessages(
          this.newsletterErrorMessage,
          "Something went wrong!"
        );
      });
  }
  submitForm(e) {
    e.preventDefault();
    const email = this.newsletter.elements["contact[email]"].value;
    if (email !== "") {
      if (this.validateEmail(email)) {
        this.shopifyForm();
      } else {
        this.errorMessages(
          this.newsletterErrorMessage,
          "Invalid Email Address."
        );
      }
    } else {
      this.errorMessages(
        this.newsletterErrorMessage,
        "Email Address Required."
      );
    }
    return false;
  }
}
customElements.define("blog-post-newsletter", BlogPostNewsletter);
document
  .querySelector(".component--site-credit")
  .addEventListener("click", () => {
    document
      .querySelector(".component--site-credit")
      .classList.toggle("component--site-credit--active");
  });
document
  .querySelector(".component--site-credit__wrapper")
  .addEventListener(".onmouseout", () => {
    document
      .querySelector(".component--site-credit")
      .classList.remove("component--site-credit--active");
  });
// Cart Drawer
class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.defaults = {
      cartDrawerClose: "[data-cart-drawer-close]",
      cartDrawerTrigger: "[data-cart-drawer-trigger]",
      cartOverlay: "[data-cart-drawer-overlay]",
    };
    this.cartData = null;
    this.bindEvents();
    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 100);
    this.debouncedOnChange.bind(this);
  }
  bindEvents() {
    const cartContainer = document.querySelector(
      ".component--cart-drawer--items"
    );
    if (cartContainer) {
      cartContainer.addEventListener("change", this.debouncedOnChange);
    }
    const cartItems = document.querySelectorAll(
      ".component--cart-drawer--line-item"
    ).length;
    document.querySelectorAll("[data-cart-drawer-count]").forEach((item) => {
      item.innerHTML = cartItems;
    });
    document
      .querySelector(this.defaults.cartDrawerTrigger)
      .addEventListener("click", this.openCart.bind(this));
    document
      .querySelectorAll(this.defaults.cartDrawerClose)
      .forEach((item) =>
        item.addEventListener("click", this.closeCart.bind(this))
      );
    document
      .querySelector(this.defaults.cartOverlay)
      .addEventListener("click", this.closeCart.bind(this));
    this.freeShippingThreshold();
  }
  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name")
    );
  }
  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section).innerHTML = this.getSectionInnerHTML(
        parsedState,
        section
      );
    });
  const productIdsToCheck = ["6977720320085", "6799805022293"];
  const cartItems = document.querySelectorAll(
    ".component--cart-drawer--line-item"
  );
  let hasTargetProduct = false;

  cartItems.forEach((item) => {
    const productId = item.getAttribute("data-product-id");
    if (productIdsToCheck.includes(productId)) {
      hasTargetProduct = true;
    }
  });

  const cartItemsContainer = document.querySelector(".component--cart-drawer--items");
  if (hasTargetProduct) {
    cartItemsContainer.classList.add("show_carrier_gift");
  } else {
    cartItemsContainer.classList.remove("show_carrier_gift");
  }
    this.bindEvents();
    this.openCart();
    this.freeShippingThreshold(parsedState);
  }
  getSectionsToRender() {
    return [`component--cart-drawer--body`, `component--cart-drawer--footer`];
  }
  getSectionInnerHTML(html, selector) {
    const h = new DOMParser().parseFromString(html, "text/html");
    return h.getElementById(selector).innerHTML;
  }
  updateQuantity(line, quantity) {
    const body = JSON.stringify({
      line,
      quantity,
    });
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then(() => {
        fetch(`/?section_id=global--cart-drawer`)
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            this.renderContents(state);
          });
      })
      .catch((e) => {
        console.log(e);
      });
  }
  freeShippingThreshold() {
    const cartTotal = JSON.parse(
      document
        .querySelector("[data-cart-drawer-total]")
        .getAttribute("data-cart-drawer-total")
    );
    const freeShippingThreshold = JSON.parse(
      document
        .querySelector("[data-free-shipping-threshold]")
        .getAttribute("data-free-shipping-threshold")
    );
    let remaining = freeShippingThreshold - cartTotal;
    remaining = remaining > 0 ? remaining : 0;
    /*console.log(remaining, cartTotal, freeShippingThreshold);*/
    document.querySelector(
      "[data-free-shipping-threshold-number]"
    ).innerHTML = `$${remaining / 100}`;
    if (cartTotal >= freeShippingThreshold) {
      document
        .querySelector(".component--cart-drawer--shipping")
        .classList.add("component--cart-drawer--shipping--active");
      document.querySelector(
        ".component--cart-drawer--shipping__bar-progress"
      ).style.width = "100%";
    } else {
      document
        .querySelector(".component--cart-drawer--shipping")
        .classList.remove("component--cart-drawer--shipping--active");
      const progressPercentage = (cartTotal / freeShippingThreshold) * 100;
      document.querySelector(
        ".component--cart-drawer--shipping__bar-progress"
      ).style.width = `${progressPercentage}%`;
    }
  }
  openCart() {
    document.body.style.overflow = "hidden";
    document.querySelector(".global--cart-drawer__drawer").style.display =
      "block";
    document
      .querySelector(".global--cart-drawer__drawer")
      .classList.add("global--cart-drawer__drawer--active");
    document
      .querySelector(".global--cart-drawer__overlay")
      .classList.add("global--cart-drawer__overlay--active");
  }
  closeCart() {
    document.body.style.overflow = "visible";
    document
      .querySelector(".global--cart-drawer__drawer")
      .classList.remove("global--cart-drawer__drawer--active");
    document
      .querySelector(".global--cart-drawer__overlay")
      .classList.remove("global--cart-drawer__overlay--active");
  }
}
customElements.define("cart-drawer", CartDrawer);
class CartDrawerAddOn extends HTMLElement {
  constructor() {
    super();
    this.selectedValue = document.querySelector(
      ".component--product--upsell__select-value"
    );
    this.bindEvents();
  }
  bindEvents() {
    if (
      document.querySelectorAll(".component--cart-drawer--upsell-slider--card")
        .length == 0
    ) {
      document.querySelector(
        ".component--cart-drawer--upsell-slider"
      ).style.display = "none";
    } else {
      document.querySelector(
        ".component--cart-drawer--upsell-slider"
      ).style.display = "block";
    }
    document
      .querySelectorAll(".component--cart-drawer--upsell-slider--card")
      .forEach((item) => {
        const customSelect = item.querySelector(
          ".component--cart-drawer--upsell-slider--card__select"
        );
        const selectBtn = item.querySelector(
          ".component--cart-drawer--upsell-slider--card__select-button"
        );
        const selectDropdown = item.querySelector(
          ".component--cart-drawer--upsell-slider--card__select-dropdown"
        );
        // add click event to select button
        selectBtn.addEventListener("click", () => {
          // add/remove active class on the container element
          customSelect.classList.toggle(
            "component--cart-drawer--upsell-slider--card__select--active"
          );
          selectDropdown.classList.toggle(
            "component--cart-drawer--upsell-slider--card__select-dropdown--active"
          );
          // update the aria-expanded attribute based on the current state
          selectBtn.setAttribute(
            "aria-expanded",
            selectBtn.getAttribute("aria-expanded") === "true"
              ? "false"
              : "true"
          );
        });
        document.addEventListener("click", this.handleClickOutside);
        selectDropdown.querySelectorAll("input").forEach((option) => {
          option.addEventListener("change", (event) =>
            this.onVariantChange(event, item)
          );
        });
      });
  }
  handleClickOutside(event) {
    document
      .querySelectorAll(".component--cart-drawer--upsell-slider--card")
      .forEach((item) => {
        const customSelect = item.querySelector(
          ".component--cart-drawer--upsell-slider--card__select"
        );
        const selectDropdown = item.querySelector(
          ".component--cart-drawer--upsell-slider--card__select-dropdown"
        );
        if (
          !customSelect.contains(event.target) &&
          customSelect.classList.contains(
            "component--cart-drawer--upsell-slider--card__select--active"
          )
        ) {
          customSelect.classList.remove(
            "component--cart-drawer--upsell-slider--card__select--active"
          );
          selectDropdown.classList.remove(
            "component--cart-drawer--upsell-slider--card__select-dropdown--active"
          );
          document.removeEventListener("click", this.handleClickOutside);
        }
      });
  }
  onVariantChange(event, item) {
    this.updateOptions(item);
    this.updateMasterId(item);
    const customSelect = item.querySelector(
      ".component--cart-drawer--upsell-slider--card__select"
    );
    const selectedValue = item.querySelector(
      ".component--cart-drawer--upsell-slider--card__select-value"
    );
    selectedValue.textContent = this.currentVariant.title;
    customSelect.classList.remove("component--product--upsell__select--active");
    const currency = document
      .querySelector(".component--cart-drawer--upsell-slider--card__price")
      .getAttribute("data-iso-code");
    var priceDollars = this.currentVariant.price / 100;
    var formattedPrice = priceDollars
      .toString()
      .replace(/\.00$/, "")
      .replace(/(\.\d*[1-9])0+$/, "$1");
    item.querySelector(
      ".component--cart-drawer--upsell-slider--card__price--sale"
    ).textContent = `$${formattedPrice} ${currency}`;
    const comparePrice = event.currentTarget.getAttribute("data-compare-price");
    if (comparePrice != "") {
      var comparePriceDollars = comparePrice / 100;
      var formattedComparePrice = comparePriceDollars
        .toString()
        .replace(/\.00$/, "")
        .replace(/(\.\d*[1-9])0+$/, "$1");
      document.querySelector(
        ".component--cart-drawer--upsell-slider--card__price--base"
      ).textContent = `$${formattedComparePrice}`;
    }
    item
      .querySelector(".component--cart-drawer--recommendations--card__form")
      .querySelector("input[name='id']").value = this.currentVariant.id;
    item
      .querySelector(
        ".component--cart-drawer--upsell-slider--card__select-dropdown"
      )
      .classList.remove(
        "component--cart-drawer--upsell-slider--card__select-dropdown--active"
      );
  }
  updateMasterId(item) {
    this.currentVariant = this.getVariantData(item).find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }
  getVariantData(item) {
    this.variantData =
      this.variantData ||
      JSON.parse(item.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
  updateOptions(item) {
    const fieldsets = Array.from(item.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}
customElements.define("cart-drawer-add-on", CartDrawerAddOn);
class CartDrawerRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.closest("cart-drawer").updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define("cart-drawer-remove-button", CartDrawerRemoveButton);
class CartDrawerQuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define("cart-drawer-quantity-input", CartDrawerQuantityInput);
class CartDrawerProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.cart = document.querySelector("cart-drawer");
  }
  onSubmitHandler(evt) {
    evt.preventDefault();
    const submitButton = this.querySelector('[type="submit"]');
    submitButton.setAttribute("disabled", true);
    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
    });
    fetch(`${routes.cart_add_url}`, { ...fetchConfig("javascript"), body })
      .then((response) => response.text())
      .then(() => {
        fetch(`/?section_id=global--cart-drawer`)
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            this.cart.renderContents(state);
          });
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.removeAttribute("disabled");
      });
  }
}
customElements.define("cart-drawer-product-form", CartDrawerProductForm);
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
      button: this.querySelector("button"),
      panel: this.querySelector("ul"),
    };
    this.elements.button.addEventListener(
      "click",
      this.openSelector.bind(this)
    );
    this.elements.button.addEventListener(
      "focusout",
      this.closeSelector.bind(this)
    );
    this.addEventListener("keyup", this.onContainerKeyUp.bind(this));
    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }
  hidePanel() {
    this.elements.button.setAttribute("aria-expanded", "false");
    this.elements.panel.setAttribute("hidden", true);
    this.elements.panel.classList.remove(
      "global-header-currency-selector__dropdown--active"
    );
  }
  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;
    this.hidePanel();
    this.elements.button.focus();
  }
  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
  openSelector() {
    this.elements.button.focus();
    //this.elements.panel.toggleAttribute("hidden");
    this.elements.panel.classList.toggle(
      "global-header-currency-selector__dropdown--active"
    );
    this.elements.button.setAttribute(
      "aria-expanded",
      (
        this.elements.button.getAttribute("aria-expanded") === "false"
      ).toString()
    );
  }
  closeSelector(event) {
    const shouldClose =
      event.relatedTarget && event.relatedTarget.nodeName === "BUTTON";
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}
customElements.define("localization-form", LocalizationForm);
class FooterLocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
      button: this.querySelector("button"),
      panel: this.querySelector("ul"),
    };
    this.elements.button.addEventListener(
      "click",
      this.openSelector.bind(this)
    );
    this.elements.button.addEventListener(
      "focusout",
      this.closeSelector.bind(this)
    );
    this.addEventListener("keyup", this.onContainerKeyUp.bind(this));
    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }
  hidePanel() {
    this.elements.button.setAttribute("aria-expanded", "false");
    this.elements.panel.setAttribute("hidden", true);
    this.elements.panel.classList.remove(
      "global-footer-currency-selector__dropdown--active"
    );
  }
  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;
    this.hidePanel();
    this.elements.button.focus();
  }
  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
  openSelector() {
    this.elements.button.focus();
    //this.elements.panel.toggleAttribute("hidden");
    this.elements.panel.classList.add(
      "global-footer-currency-selector__dropdown--active"
    );
    this.elements.button.setAttribute(
      "aria-expanded",
      (
        this.elements.button.getAttribute("aria-expanded") === "false"
      ).toString()
    );
  }
  closeSelector(event) {
    const shouldClose =
      event.relatedTarget && event.relatedTarget.nodeName === "BUTTON";
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}
customElements.define("footer-localization-form", FooterLocalizationForm);
class MobileFooterLocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
    };
    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }
  hidePanel() {
    this.elements.button.setAttribute("aria-expanded", "false");
    this.elements.panel.setAttribute("hidden", true);
    this.elements.panel.classList.remove(
      "global-footer-currency-selector__dropdown--active"
    );
  }
  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;
    this.hidePanel();
    this.elements.button.focus();
  }
  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}
customElements.define(
  "footer-mobile-localization-form",
  MobileFooterLocalizationForm
);
class MobileHeaderLocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
      button: this.querySelector("button"),
      panel: this.querySelector("ul"),
    };
    this.elements.button.addEventListener(
      "click",
      this.openSelector.bind(this)
    );
    this.elements.button.addEventListener(
      "focusout",
      this.closeSelector.bind(this)
    );
    this.addEventListener("keyup", this.onContainerKeyUp.bind(this));
    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }
  hidePanel() {
    this.elements.button.setAttribute("aria-expanded", "false");
    this.elements.panel.setAttribute("hidden", true);
    this.elements.panel.classList.remove(
      "global-header-mobile-currency-selector__dropdown--active"
    );
  }
  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;
    this.hidePanel();
    this.elements.button.focus();
  }
  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
  openSelector() {
    this.elements.button.focus();
    //this.elements.panel.toggleAttribute("hidden");
    this.elements.panel.classList.toggle(
      "global-header-mobile-currency-selector__dropdown--active"
    );
    this.elements.button.setAttribute(
      "aria-expanded",
      (
        this.elements.button.getAttribute("aria-expanded") === "false"
      ).toString()
    );
  }
  closeSelector(event) {
    const shouldClose =
      event.relatedTarget && event.relatedTarget.nodeName === "BUTTON";
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}
customElements.define("mobile-localization-form", MobileHeaderLocalizationForm);
// document.addEventListener("DOMContentLoaded", function () {
//   function removeCents(price) {
//     price = price.replace("$", "").replace(/,/g, "");
//     price = parseFloat(price);
//     let roundedPrice = Math.floor(price);
//     return `$${roundedPrice.toLocaleString()}`;
//   }
//   if (document.querySelectorAll("[data-discount-amount]").length > 0) {
//     document.querySelectorAll("[data-discount-amount]").forEach(function (el) {
//       const price = el.getAttribute("data-discount-amount");
//       const formattedprice = removeCents(price);
//       el.innerHTML = `Save ${formattedprice}`;
//     });
//   }
// });


var number; 

// Function to handle radio change
function handleRadioChange() {
    var checkedRadio = $('.component--product--case-selector__options-box input[type="radio"]:checked');
    var checkedLabelQty = checkedRadio.next('label');
    var checkedQuantity = checkedLabelQty.data('case-index'); // Use .data() to get data-case-index attribute
    number = checkedQuantity; // Assign the value to number variable

    console.log("Checked Quantity:", checkedQuantity);

           // Find the price inside the label
    var price = checkedLabelQty.find('.component--product--case-selector__label-item__price').text();
    console.log("Price:", price);

    // Append this price to .component--product--price__sale
    $('.component--product--price__sale').text(price);

      var discount = checkedLabelQty.find('.component--product--case-selector__label-item__discount').text();
    console.log("Discount:", discount);

    // Append this discount to .component--product--price__discount
    $('.component--product--price__discount').text(discount);

}

// Event delegation for .component--product--case-selector__options-box input[type="radio"]
$(document).on('change', '.component--product--case-selector__options-box input[type="radio"]', handleRadioChange);

// Event delegation for .component--product--variant-selector__field input[type="radio"]
$(document).on('change', '.component--product--variant-selector__field input[type="radio"]', function() {
    // Trigger change on the first radio in .component--product--case-selector__options-box
    $('.component--product--case-selector__options-box input[type="radio"]').first().prop('checked', true).trigger('change');
});

// Trigger change on the first radio in .component--product--case-selector__options-box on page load
$(document).ready(function() {
  $('.component--product--case-selector__options-box input[type="radio"]').trigger('change');
   // $('.component--product--case-selector__options-box input[type="radio"]').first().prop('checked', true).trigger('change');
});



